<template>
  <div class="c-bottom-pad" :class="{ 'is-tab-page': isTabPage }"></div>
</template>

<script>
export default {
  props: {
    isTabPage: Boolean,
  },
};
</script>

<style lang="less" scoped>
.c-bottom-pad {
  height: constant(safe-area-inset-bottom);
  height: env(safe-area-inset-bottom);

  &.is-tab-page {
    height: calc(3.1rem + constant(safe-area-inset-bottom));
    height: calc(3.1rem + env(safe-area-inset-bottom));
  }
}
</style>
